import { WSElement, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { DataView } from "../../../shared/components/DataView";

type Props = {
  workLog?: IWorkLog;
  shimmer?: boolean;
};

export const WorkLogAdditionalDetailsPayeeView: React.FC<Props> = props => {
  return (
    <WSElement>
      <WSSectionToolbar title="Additional details" />
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Notes",
            value: "No notes",
            fullWidth: true
          },
          {
            label: "Attachments (optional)",
            value: "No attachments",
            fullWidth: true
          }
        ]}
      />
    </WSElement>
  );
};
